import template from './sw-cms-el-preview-product-description-reviews.html.twig';
import './sw-cms-el-preview-product-description-reviews.scss';

/**
 * @private
 * @package buyers-experience
 */
export default {
    template,
};
